export default "__VITE_ASSET__q$$xG4yl__"